import { gql } from '@apollo/client';

export const fetchTermPaymentAuditTrailsPPC = gql`
  query fetchTermPaymentAuditTrailsPPC(
    $searchParams: TermPaymentAuditTrailSearchParams
    $searchOptions: TermPaymentAuditTrailsSearchOptions
  ) {
    termPaymentAuditTrails(searchParams: $searchParams, searchOptions: $searchOptions) {
      totalCount
      nodes {
        id
        comments
        updatedBy
        createdAt
        revisionNumber
        revisionType
      }
    }
  }
`;
